import React, { ReactNode } from 'react';
import styles from './AuthLayout.module.scss';
import { cx } from '@emotion/css';

type AuthLayoutProps = {
    children?: ReactNode;
    className?: string;
};

export default function AuthLayout(props: AuthLayoutProps) {
    const { children, className } = props;
    return <div className={cx(styles.auth, className)}>{children}</div>;
}
